import React from 'react';
import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import AhaEditorFieldV2Controller from 'components/aha_editor_field_v2/controllers/AhaEditorFieldV2Controller';

class ToolUnlockDocument extends Tool {
  static toolName = 'Edit document';
  static iconClass = 'fa-regular fa-edit';

  static available({ controller }: ToolArgsWithController) {
    const editorFieldController = controller.findControllerInstance(
      AhaEditorFieldV2Controller
    );
    return Boolean(editorFieldController?.isLocked);
  }

  static action({ editor, controller }: ToolArgsWithController) {
    const editorFieldController = controller.findControllerInstance(
      AhaEditorFieldV2Controller
    );
    editorFieldController?.actionUnlockDocument();
  }

  static renderToolbarButtonIcon(
    toolArgs: ToolArgsWithController
  ): JSX.Element {
    return (
      <span>
        <i className={this.iconClass} />
        &nbsp;Edit
      </span>
    );
  }
}

export default ToolUnlockDocument;
